/** Formati nella lingua dell'interfaccia (it-IT o en-GB), letti a ogni chiamata: cambiano con il selettore IT/EN. */
import type { Valuta } from "@qa/shared";
import { locale } from "../i18n";

const cache = new Map<string, Intl.NumberFormat>();
const nf = (nome: string, opts: Intl.NumberFormatOptions) => {
  const k = `${locale()}|${nome}`;
  let f = cache.get(k);
  if (!f) cache.set(k, (f = new Intl.NumberFormat(locale(), opts)));
  return f;
};
// useGrouping "always": in italiano Intl non separa le migliaia sotto 10.000
const moneta = (v: Valuta) => nf(`m-${v}`, { style: "currency", currency: v, maximumFractionDigits: 0, useGrouping: "always" });
const intero = () => nf("int", { maximumFractionDigits: 0, useGrouping: "always" });
const dec = (d: number) => nf(`dec${d}`, { minimumFractionDigits: d, maximumFractionDigits: d });

export const VUOTO = "—";
export const fmtImporto = (v: number | null | undefined, valuta: Valuta = "EUR") => (v === null || v === undefined ? VUOTO : moneta(valuta).format(v));
export const fmtEur = (v: number | null | undefined) => fmtImporto(v, "EUR");
export const fmtNum = (v: number | null | undefined) => (v === null || v === undefined ? VUOTO : intero().format(v));
export const fmtDec = (v: number | null | undefined, d = 2) => (v === null || v === undefined ? VUOTO : dec(d).format(v));
/** Importi compatti per i KPI: 1,25 M€ · 340 k€. */
export function fmtK(v: number | null | undefined) {
  if (v === null || v === undefined) return VUOTO;
  if (Math.abs(v) >= 1e6) return `${dec(2).format(v / 1e6)} M€`;
  if (Math.abs(v) >= 1000) return `${intero().format(Math.round(v / 1000))} k€`;
  return fmtEur(v);
}
export const fmtData = (iso: string | null | undefined) => (iso ? new Date(iso.length === 10 ? `${iso}T00:00:00` : iso).toLocaleDateString(locale(), { day: "2-digit", month: "2-digit", year: "numeric" }) : VUOTO);
export const fmtDataOra = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString(locale(), { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : VUOTO;

/** Separatori della lingua corrente per gli InputNumber. */
const separatori = () => (locale() === "it-IT" ? { migliaia: ".", decimali: "," } : { migliaia: ",", decimali: "." });
export const numFormatter = (v: number | string | undefined) => {
  if (v === undefined || v === "") return "";
  const [i, d] = `${v}`.split(".");
  const { migliaia, decimali } = separatori();
  return i.replace(/\B(?=(\d{3})+(?!\d))/g, migliaia) + (d !== undefined ? decimali + d : "");
};
export const numParser = (v: string | undefined) => {
  const { migliaia, decimali } = separatori();
  return Number((v ?? "").split(migliaia).join("").replace(decimali, ".").replace(/[^\d.-]/g, "")) as unknown as number;
};
